/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileApi } from './api/profile.api';

@Injectable()
export class ProfileService {
  constructor(private profileApi:ProfileApi) {
  }

  getAuthenticatedMenus():Observable<any> {
    return this.profileApi.getAuthentecatedMenu()
  }
}
